import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import css from './patientCard.css'

const formatBirthday = (birthday) => {
  const date = moment(birthday)

  return {
    year: date.format('YY'),
    month: date.format('MMM'),
    day: date.format('D'),
    age: moment().diff(date, 'years'),
  }
}

const PatientPersonalInfo = ({ patient }) => {
  let ageData
  let tada
  const month = moment().format('MMM')
  const day = moment().format('D')

  if (patient.birthday) {
    const dob = formatBirthday(patient.birthday)

    tada = (
      <div>
        {(dob.month === month && dob.day === day) &&
          <span className={css.tada} role="img" aria-label="tada">🎉</span>}
      </div>
    )

    ageData = (
      <div className={css.dobLine}>
        {tada}
        <div className={css.dobText}>
          <span className={css.dobPart}>{`${dob.month} ${dob.day}, '${dob.year}`}</span>
          <span className={css.verticalLine} />
          <span className={css.dobPart}>{`${dob.age} years old`}</span>
        </div>
        {tada}
      </div>
    )
  }

  return (
    <div>
      <p className={css.nameIcon}>{`${patient.first_name[0]}${patient.last_name[0]}`}</p>
      <div className={css.personalInfo}>
        <p className={css.name}>{`${patient.first_name} ${patient.last_name}`}</p>
        {ageData}
      </div>
    </div>
  )
}

export default PatientPersonalInfo



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/PersonalInfo.js